import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Cross1Icon } from '@radix-ui/react-icons';
import { BiChevronDown } from 'react-icons/bi';
import { Pill as LuPill } from 'lucide-react';
import { PiFunnelBold } from 'react-icons/pi';

export const CATEGORY_CONFIG = {
  categoryCard: {
    arrowIcon: <LuPill className="h-5 w-5" color="hsl(var(--primary))" />,
  },
  categorySort: {
    expandIcon: <BiChevronDown className="h-9 w-9 opacity-50" fill="hsl(var(--primary))" />,
    clearIcon: (
      <Cross1Icon className="h-4 w-4 cursor-pointer opacity-50" fill="hsl(var(--primary))" />
    ),
  },
  categoryFilter: {
    funnelIcon: <PiFunnelBold className="bg-red h-5 w-5" fill="hsl(var(--primary))" />,
    chevronIcon: (
      <BiChevronDown
        className="h-9 w-9 opacity-50 data-[state=expanded]:rotate-180"
        fill="hsl(var(--primary))"
      />
    ),
  },
};
